var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-search-item-container row"},[_c('span',[_vm._v("  ")]),_c('div',{ref:"text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }